var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "div",
              [
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.dialog,
                      callback: function($$v) {
                        _vm.dialog = $$v
                      },
                      expression: "dialog"
                    }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "activator" }, slot: "activator" },
                      [
                        _c(
                          "v-tooltip",
                          { attrs: { right: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "elevation-10",
                                attrs: {
                                  slot: "activator",
                                  fab: "",
                                  large: "",
                                  color: "primary darken-1",
                                  dark: ""
                                },
                                slot: "activator"
                              },
                              [_c("v-icon", [_vm._v("add")])],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Add a new layout")])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _c("span", { staticClass: "headline" }, [
                            _vm._v(_vm._s(_vm.formTitle))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "view_column",
                                            label: "Name",
                                            name: "name",
                                            "error-messages": _vm.form.errors.has(
                                              "name"
                                            )
                                              ? _vm.form.errors.get("name")
                                              : []
                                          },
                                          on: {
                                            keypress: function($event) {
                                              _vm.form.errors.clear("name")
                                            }
                                          },
                                          model: {
                                            value: _vm.editedItem.name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editedItem,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "editedItem.name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.layoutTypes,
                                            "item-text": "text",
                                            label: "Layout Type",
                                            name: "type",
                                            "prepend-icon": "account_balance",
                                            auto: "",
                                            disabled: _vm.editedIndex !== -1,
                                            "error-messages": _vm.form.errors.has(
                                              "type"
                                            )
                                              ? _vm.form.errors.get("type")
                                              : []
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.form.errors.clear("type")
                                            }
                                          },
                                          model: {
                                            value: _vm.editedItem.type,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editedItem,
                                                "type",
                                                $$v
                                              )
                                            },
                                            expression: "editedItem.type"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            outline: "",
                                            rows: "3",
                                            label: "Description",
                                            name: "description",
                                            "error-messages": _vm.form.errors.has(
                                              "description"
                                            )
                                              ? _vm.form.errors.get(
                                                  "description"
                                                )
                                              : []
                                          },
                                          on: {
                                            keypress: function($event) {
                                              _vm.form.errors.clear(
                                                "description"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.editedItem.description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editedItem,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "editedItem.description"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary darken-1", flat: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close($event)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { left: "", dark: "" } },
                                  [_vm._v("arrow_back")]
                                ),
                                _vm._v(
                                  "\n                Cancel\n              "
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary darken-1",
                                  loading: _vm.formLoading
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.save($event)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { left: "", dark: "" } },
                                  [_vm._v("save")]
                                ),
                                _vm._v("\n                Save\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", fullscreen: "", scrollable: "" },
          model: {
            value: _vm.seatsDialog,
            callback: function($$v) {
              _vm.seatsDialog = $$v
            },
            expression: "seatsDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { card: "", dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.closeLayoutDesigner($event)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.slotsLayoutName) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { dark: "", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.saveDesign($event)
                            }
                          }
                        },
                        [
                          _vm._v("Save "),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("save")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  ref: "canvasContainer",
                  style: { height: _vm.cContainerHeight + "px" }
                },
                [
                  _c("c-floor-plan-designer", {
                    attrs: {
                      "canvas-width": _vm.canvasWidth,
                      "canvas-height": _vm.canvasHeight,
                      "selected-layout": _vm.selectedLayout,
                      "trigger-save": _vm.triggerSaveDesign,
                      "designer-modal-closed": !_vm.seatsDialog
                    },
                    on: {
                      "layout-components-saved": function($event) {
                        _vm.closeSeatsDialog($event)
                      },
                      "reset-save-btn": _vm.resetSaveBtn
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-actions")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "elevation-5" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [_vm._v("Layouts")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: "Search",
                  "single-line": "",
                  "hide-details": ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchLayouts($event)
                  }
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.headers,
                items: _vm.layouts,
                pagination: _vm.pagination,
                "total-items": _vm.totalLayouts,
                "rows-per-page-items": _vm.rowsPerPageItems,
                loading: _vm.tableLoading,
                "must-sort": true
              },
              on: {
                "update:pagination": function($event) {
                  _vm.pagination = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("td", [_vm._v(_vm._s(props.item.id))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.type))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.description))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "justify-center layout px-0" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", "justify-center": "" } },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-tooltip",
                                    { attrs: { top: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            slot: "activator",
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.showSeatsPreview(props.item)
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("event_seat")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Seats preview")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { top: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: { slot: "activator", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.editItem(props.item)
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { color: "teal" } }, [
                                    _vm._v("edit")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Edit")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { top: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: { slot: "activator", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.deleteItem(props.item)
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { color: "pink" } }, [
                                    _vm._v("delete")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Delete")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("v-progress-linear", {
                attrs: { slot: "progress", color: "blue", indeterminate: "" },
                slot: "progress"
              }),
              _vm._v(" "),
              _vm.noResourcesFound
                ? _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: true,
                            color: "error",
                            icon: "warning"
                          }
                        },
                        [
                          _vm._v(
                            "\n          Sorry, no layouts found please start by adding some layouts\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  attrs: {
                    slot: "no-results",
                    value: true,
                    color: "error",
                    icon: "warning"
                  },
                  slot: "no-results"
                },
                [
                  _vm._v(
                    '\n        Your search for "' +
                      _vm._s(_vm.search) +
                      '" found no results.\n      '
                  )
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: _vm.snackbarTimeout,
            color: _vm.snackbarColor,
            top: ""
          },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_c("v-icon", { attrs: { color: "black" } }, [_vm._v("close")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba273ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba273ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Layouts.vue
// module id = null
// module chunks = 